<template>
    <div class="d-flex flex-column">
        <order-price
            v-if="!isAgency && !$conf.public.account.licenseeForCorporateCompany && !isStaticPackage"
            :title="isTourOperator ? 'client_price' : null"
            :subtitle="isStaticPackage ? 'part_of_package' : null"
            :price="clientPrice"
            :payment-status="customerPaymentStatus"
            :cancel-penalties="clientCancelPenalties"
            :show-commission="isTourOperator"
            :loyalty-points="isB2C ? loyaltyPoints : null"
            :service-card-guarantee="serviceCardGuarantee"
            :service="service"
            :hide-cancel-penalties="isBankFee"
            :discount="clientDiscount"
            _data-cy="client-price"
        >
            <slot name="violation" />
        </order-price>
        <div v-if="isTourOperator || isAgency">
            <v-divider v-if="commissionAndNettoCheckbox && !isStaticPackage" class="mt-2 pb-2" />
            <order-price
                v-if="commissionAndNettoCheckbox"
                :title="isAgency ? 'price' : 'supplier_price'"
                :price="supplierPrice"
                :payment-status="supplierPaymentStatus"
                :cancel-penalties="supplierCancelPenalties"
                :show-commission="true"
                :loyalty-points="loyaltyPoints"
                :service-card-guarantee="serviceCardGuarantee"
                :service="service"
                :discount="supplierDiscount"
                :hide-cancel-penalties="isBankFee"
                _data-cy="supplier-price"
                show-pricing-source-type
            >
                <template v-slot:income>
                    <v-row v-if="isTourOperator && income?.amount && !isStaticPackage" no-gutters>
                        <v-divider class="mt-2 pb-2" />
                        <div class="commission-block full-width">
                            <span class="text-body-2">
                                {{ $t('income') }}
                            </span>
                            <div class="text-end">
                                <p class="text-green text-subtitle-1 font-weight-medium">
                                    {{ income.amoun > 0 ? '+' : '' }}
                                    {{ $filters.priceFormat(income.amount, income.currency) }}
                                </p>
                                <p v-if="income?.percent" class="text-body-2 text-medium-emphasis">
                                    {{ `${income.percent}%` }}
                                </p>
                            </div>
                        </div>
                    </v-row>
                </template>
            </order-price>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Inject, Prop, Vue} from 'vue-facing-decorator'
    import OrderPrice from '~src/components/account/snippets/orderPrice.src'
    import CorporatePolicyViolation from '~/components/snippets/CorporatePolicyViolation.vue'

    @Component({
        components: {
            OrderPrice,
            CorporatePolicyViolation,
        },
    })
    export class OrderPrices extends Vue {
        @Prop() supplierPrice
        @Prop() supplierPaymentStatus
        @Prop() supplierCancelPenalties
        @Prop() clientPrice
        @Prop() customerPaymentStatus
        @Prop() clientCancelPenalties
        @Prop() serviceCardGuarantee
        @Prop() loyaltyPoints
        @Prop({default: 'justify-space-around'}) alignment
        @Prop() service
        @Prop() isStaticPackage
        @Inject({default: []}) preparedServices

        get isTourOperator() {
            return authStore.isTourOperator
        }

        get isAgency() {
            return authStore.isAgency
        }

        get commissionAndNettoCheckbox() {
            return persistentStore.commissionAndNettoCheckbox
        }

        get clientDiscount() {
            return this.service?.salesTerms.find(({type}) => type === 'CLIENT').discount
        }

        get supplierDiscount() {
            return this.service?.salesTerms.find(({type}) => type === 'SUPPLIER').discount
        }

        get isBankFee() {
            return this.service?.serviceDetails?.[0]?.extraServiceProductType === 'BANK_FEE'
        }

        get income() {
            if (!this.service?.serviceId) return
            return this.preparedServices.find(({serviceId}) => serviceId === this.service.serviceId)?.income
        }

        get isB2C() {
            return authStore.isB2C
        }
    }

    export default OrderPrices
</script>

<style scoped>
    .width-50 {
        width: 50%;
    }
    :deep(.commission-block) {
        font-size: 12px !important;
    }
    :deep(.payment-status-label) {
        font-size: 12px !important;
    }
    :deep(.conditions-label) {
        max-width: none;
    }
</style>
